import config from "../../config"
import RequestService from "../RequestService"

const deleteTicket = (id, successCallback, failureCallback) => {
  RequestService.delete(`${config.backendUrl}/tickets/${id}`, successCallback, failureCallback)
}

export default deleteTicket;